import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { RxHeart, RxHeartFilled } from "react-icons/rx";
import { callApi, CDN_URL, formatMoneyShorten } from "../Helpers";
import { FaRegCommentDots } from "react-icons/fa";

export default function View({ data }) {
	const appContext = useContext(AppContext);

	const [isLiked, setIsLiked] = useState(false);
	const [numberOfLikes, setNumberOfLikes] = useState(0);


	function likesBuffer() {
		if(data) {
			return ((data.title.length) * 17);
		}

		return 121;
	}

	function view(e) {
		e.stopPropagation();

		appContext.navTo({
			item: 'view',
			subItem: 'article',
			extraItem: data.id,
		});
	}

	async function like(e) {

		e.stopPropagation();

		if (!isLiked) {
			setIsLiked(true);
			setNumberOfLikes(_prev => Number(_prev) + 1)
			await callApi('like-article', { id: data.id }).then(response => {
				if(response.status === 1) {
					//good action
				}
			})
		}
	}

	useEffect(() => {
		if(data) {
			const likes = JSON.parse(data.likes);
			setNumberOfLikes(likes.length + likesBuffer());

			if(appContext.auth && appContext.currentUserData) {
				for (const like of likes) {
					if(Number(like) === Number(appContext.currentUserData.id)) {
						setIsLiked(true);
						break;
					}
				}
			}
		}
	}, [data])

	return (
		<div
			
			style={{
				width: "100%",
				height: "270px",
				padding: "10px",
			}}
		>
			<img
				style={{
					height: "calc(100% - 64.8px)",
					width: "100%",
					objectFit: "cover",
					borderRadius: "20px",
					overflow: "none"
				}}
				src={CDN_URL+data.cover}
				className="mNoMargin"
				onClick={view}
			/>
			<h6
				className="mNoMargin font-semi-bold"
				style={{
					paddingTop: "5px",
					fontSize: "18px",
					lineHeight: "21.6px", // 1.2 * 18px for clarity
					overflow: "hidden",
					display: "-webkit-box",
					WebkitLineClamp: 3,
					WebkitBoxOrient: "vertical",
					textOverflow: "ellipsis",
					maxHeight: "64.8px", // 3 lines * 21.6px line height
					cursor: "pointer"
				}}
				onClick={view}
			>
				{data.title}
			</h6>

			

			
		</div>
	);
}
